import { render, staticRenderFns } from "./bairunCommentRecord.vue?vue&type=template&id=519a9437&scoped=true&"
import script from "./bairunCommentRecord.vue?vue&type=script&lang=js&"
export * from "./bairunCommentRecord.vue?vue&type=script&lang=js&"
import style0 from "./bairunCommentRecord.vue?vue&type=style&index=0&id=519a9437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519a9437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519a9437')) {
      api.createRecord('519a9437', component.options)
    } else {
      api.reload('519a9437', component.options)
    }
    module.hot.accept("./bairunCommentRecord.vue?vue&type=template&id=519a9437&scoped=true&", function () {
      api.rerender('519a9437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/bairunComment/bairunCommentRecord.vue"
export default component.exports